<template lang="pug">
div(:class="$style.dialogLayout")
  div(:class="[$style.boxContainer, blockData.dialogClass]")
    Block(
      v-for="(innerBlock, key) in blockData.dialogContent"
      v-bind="{ id: 'image-dialog-block' + '-' + key, class: 'image-dialog-block' }"
      :key="`imageDialogBlock${key}`"
      :block="innerBlock")
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { getAttributes } from "~/utils/block"
import { replaceUrlS3 } from "~/utils/imageUrlS3"

interface BlockData {
  imageURL: string
  mobileImageURL: string
  tabletImageURL: string
  dialogContent: any[]
  dialogClass: string
}

interface ComponentData {
  blockData: BlockData
}

export default defineComponent({
  name: "ImageDialog",

  props: {
    block: {
      type: Object as () => Record<string, any>,
      required: true
    },
    data: {
      type: Object as () => BlockData,
      required: false,
      default: () => ({})
    }
  },

  data(): ComponentData {
    return {
      blockData: {
        imageURL: "",
        mobileImageURL: "",
        tabletImageURL: "",
        dialogContent: [],
        dialogClass: ""
      }
    }
  },

  mounted(): void {
    this.mapData()
  },

  methods: {
    getAttributes,
    replaceUrlS3,

    mapData(): void {
      this.blockData.imageURL = this.block.innerBlocks[0].attributes.find(
        item => item.name === "url"
      ).value
      this.blockData.tabletImageURL = this.blockData.imageURL
      if (this.block.innerBlocks[1]) {
        this.blockData.tabletImageURL = this.block.innerBlocks[1]?.attributes.find(
          item => item.name === "url"
        ).value
      }
      this.blockData.mobileImageURL = this.blockData.tabletImageURL
      if (this.block.innerBlocks[2]) {
        this.blockData.mobileImageURL = this.block.innerBlocks[2]?.attributes.find(
          item => item.name === "url"
        ).value
      }

      document.documentElement.style.setProperty(
        "--dialog-section-background",
        `url(${this.replaceUrlS3(this.blockData.imageURL, this.$config.public)})`
      )
      document.documentElement.style.setProperty(
        "--dialog-section-tablet-background",
        `url(${this.replaceUrlS3(this.blockData.tabletImageURL, this.$config.public)})`
      )
      document.documentElement.style.setProperty(
        "--dialog-section-mobile-background",
        `url(${this.replaceUrlS3(this.blockData.mobileImageURL, this.$config.public)})`
      )

      this.blockData.dialogContent =
        this.block.innerBlocks[0].innerBlocks[1].innerBlocks[1].innerBlocks[0].innerBlocks
      this.blockData.dialogClass = this.getAttributes(
        this.block.innerBlocks[0].innerBlocks[1].innerBlocks[1].innerBlocks[0]
      ).class
    }
  }
})
</script>

<style lang="css" module>
:global(.image-dialog) {
  @apply content-end;
}
.dialogLayout {
  display: flex;
  justify-content: space-around;

  :global {
    .av-heading,
    .av-paragraph {
      @apply mb-ds-ml;
    }

    .av-button {
      @apply text-center mt-0;
    }
  }
}

.boxContainer {
  @apply p-ds-md flex flex-col;
  border-radius: 16px;
  margin-top: 262px;
  max-width: 397px;
  box-shadow: 0 -16px 32px 0 rgba(0, 0, 0, 0.5);
}

@screen md {
  .dialogLayout {
    :global {
      .av-button {
        @apply w-full;
      }
    }
  }

  .boxContainer {
    @apply mt-0;
    align-self: flex-end;
    max-width: unset;
    width: 512px;
    box-shadow: 0 -16px 16px 0 rgba(0, 0, 0, 0.25);
  }
}

@screen xl {
  .dialogLayout {
    justify-content: flex-end;

    :global {
      .av-button {
        width: inherit;
      }
    }
  }

  .boxContainer {
    @apply mx-0 p-ds-xl;
    box-shadow: 0 16px 32px 0 rgba(0, 0, 0, 0.5);
    width: 576px;
  }
}
</style>
